var SwiperPublications = {
    init:function(){
        var swiper = new Swiper(".akrolab-slider-publications .swiper-container", {
            slidesPerView:'auto',
            spaceBetween: 20,
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                draggable: true,
              },
              breakpoints: {                  
                  1040: {
                      spaceBetween: 45,
                  }
                }
          });
    }
}

$(window).load(function(){
    if($('.akrolab-slider-publications').length){
        SwiperPublications.init();
    }
})